import React, { PureComponent } from 'react'
import ButtonFile from '../ButtonFile'
import Select from '../Select'
import './index.css'

class Media extends PureComponent {
  state = {
    image: null,
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.image !== this.state.image && this.props.onPreview) {
      this.props.onPreview(this.state.image)
    }
  }

  handleChange(image) {
    if (this.props.onChange) {
      this.props.onChange(image)
    }
  }

  handleReaderLoad = (e) => this.setState({ image: e.target.result })

  handleFileChange = (e) => {
    e.persist()

    const [file] = e.target.files

    if (file) {
      const reader = new FileReader()
      reader.onload = this.handleReaderLoad
      reader.readAsDataURL(file)
      this.handleChange(file)
    }
  }

  handleSelectChange = (image) => this.setState(
    { image },
    () => this.handleChange(image),
  )

  render() {
    return (
      <div className={ 'media' }>
        <div className={ 'media-head' }>
          <Select onChange={ this.handleSelectChange }>
            GIPHY
          </Select>

          <div className={ 'media-divider' }>
            ou
          </div>

          <ButtonFile onChange={ this.handleFileChange }>
            Upload
          </ButtonFile>
        </div>

        <div className={ 'media-body' }>
          {
            this.state.image
            ? (
              <img
                src={ this.state.image }
                alt="Preview local file" />
            )
            : (
              <div className={ 'media-body-placeholder' }>
                aucun GIF sélectionné
              </div>
            )
          }
        </div>
      </div>
    )
  }
}

export default Media



// WEBPACK FOOTER //
// ./src/components/Media/index.js